import React, { useEffect, useRef } from 'react';
import { TextField, Box } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { useTranslation } from 'react-i18next';
import FilterSelect from './FilterSelect';
import { FiltersComponentProps, SetDates, FromToDate } from './types';
import { TableIcon } from '../SVGIcons';
import FromToPicker from './FromToPicker';
import { SpacedInputBox } from './style';

const FiltersComponent = <T extends {date: FromToDate; name: string; place: string; openedBy: string},>(
    { formData, handleChange, setFormData, options, children }: FiltersComponentProps<T>
) => {
    const { placesOptions, openedByOptions } = options;
    const { date: { from: fromDate, to: toDate } } = formData ;
    const { t } = useTranslation();

    const previousDates = useRef<FromToDate>({ from: fromDate, to: toDate });
    const reset = useRef(false);
    useEffect(() => {
        const { current } = previousDates;
        if (current.from && current.to && !(fromDate && toDate)){
            reset.current = true;
        } else {
            reset.current = false;
        }
        previousDates.current = { from: fromDate, to: toDate };
    }, [fromDate, toDate]);

    const setDates: SetDates = ({ from, to }) => {
        setFormData({ ...formData, date: { from, to } });
    };
    return (
        <Box display='flex' alignItems='center' flexGrow={1}>
            <SpacedInputBox width={144}>
                <TextField
                    size='small'
                    id="name"
                    label={t('Name')}
                    name='name'
                    value={formData.name}
                    onChange={handleChange}
                    fullWidth
                    variant='outlined'
                />
            </SpacedInputBox>
            <SpacedInputBox width={144}>
                <FilterSelect
                    options={placesOptions}
                    handleChange={handleChange}
                    value={formData.place}
                    fieldName='place'
                    label={(
                        <Box display='flex' height={16}>
                            <Box mr={.5}>
                                <TableIcon fontSize='inherit' />
                            </Box>
                            {t('Place')}
                        </Box>
                    )}
                />
            </SpacedInputBox>
            <SpacedInputBox width={144}>
                <FilterSelect
                    options={openedByOptions}
                    handleChange={handleChange}
                    value={formData.openedBy}
                    fieldName='openedBy'
                    label={(
                        <Box display='flex' height={16}>
                            <Box mr={.5}>
                                <PersonIcon fontSize='inherit' />
                            </Box>
                            {t('Opened By')}
                        </Box>
                    )}
                />
            </SpacedInputBox>
            <SpacedInputBox>
                <FromToPicker reset={reset.current} setDates={setDates} />
            </SpacedInputBox>
            <SpacedInputBox display='flex' alignItems='center' justifyContent='space-between' flexGrow={1}>
                {children}
            </SpacedInputBox>
        </Box>

    );
};

export default FiltersComponent;
